import AuthLogo from './logos/auth-logo.svg';
import AuthBgImage from './auth-bg-image.svg';
import Block2FAImg from "./block-2fa.png"


export default {
  AuthLogo,
  AuthBgImage,
  Block2FAImg
}